import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Button.css';

const Button = ({
  text,
  onClick,
  iconClass,
  link,
  isExternal = false,
  reverse = false,
  backgroundColor, // 🎯 new prop for custom color
}) => {
  const style = backgroundColor ? { backgroundColor, color: '#fff' } : {};

  const buttonContent = (
    <>
      {iconClass && <i className={`fa ${iconClass} icon-left`} aria-hidden="true"></i>}
      <span>{text}</span>
    </>
  );

  const buttonClass = `custom-button ${reverse ? 'custom-button-reverse' : ''}`;

  if (link) {
    return isExternal ? (
      <a
        href={link}
        className={buttonClass}
        style={style}
        target="_blank"
        rel="noopener noreferrer"
      >
        {buttonContent}
      </a>
    ) : (
      <Link to={link} className={buttonClass} style={style}>
        {buttonContent}
      </Link>
    );
  }

  return (
    <button className={buttonClass} onClick={onClick} style={style}>
      {buttonContent}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  iconClass: PropTypes.string,
  link: PropTypes.string,
  isExternal: PropTypes.bool,
  reverse: PropTypes.bool,
  backgroundColor: PropTypes.string, // 🎯 for custom styling
};

export default Button;
